var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "custom-permissions-container" },
    [
      _vm.componentIsRendered
        ? _c("div", { staticClass: "custom-permissions" }, [
            _c("fieldset", { staticClass: "fieldset" }, [
              _c("legend", { staticClass: "fieldset-legend" }, [
                _vm._v(_vm._s(_vm.texts.legend)),
              ]),
              _c(
                "div",
                { staticClass: "permissions-container" },
                [
                  _c(
                    "div",
                    { staticClass: "selected-permission-info-row" },
                    [
                      _c("LexonSwitchComponent", {
                        staticClass: "lexon-switch",
                        attrs: {
                          id: "all-selected",
                          label: _vm.texts.allPermissionsSelected,
                          returnBoolean: true,
                        },
                        on: {
                          "emit-click-event": _vm.toggleSelectAllPermissions,
                        },
                        model: {
                          value: _vm.componentData.allSelected,
                          callback: function ($$v) {
                            _vm.$set(_vm.componentData, "allSelected", $$v)
                          },
                          expression: "componentData.allSelected",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "permission-types-container" },
                        _vm._l(
                          _vm.permissionTypeHeaders,
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "info-text" },
                              [
                                _c("span", { class: [item.icon, "type-icon"] }),
                                _c("span", [_vm._v(_vm._s(item.text))]),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-expansion-panels",
                    { attrs: { multiple: "" } },
                    _vm._l(
                      _vm.componentData.permissions,
                      function (permission) {
                        return _c(
                          "v-expansion-panel",
                          { key: permission.idEntity },
                          [
                            _c("v-expansion-panel-header", [
                              _c("div", { staticClass: "permission-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "switch-container" },
                                  [
                                    _c("LexonSwitchComponent", {
                                      staticClass: "lexon-switch",
                                      attrs: {
                                        id: "all-selected",
                                        label: permission.label,
                                        returnBoolean: true,
                                      },
                                      on: {
                                        "emit-click-event":
                                          _vm.checkIfAllPermissionsAreActivated,
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.renderCheckboxesStatus(
                                            permission.activated,
                                            permission.idEntity
                                          )
                                        },
                                      },
                                      model: {
                                        value: permission.activated,
                                        callback: function ($$v) {
                                          _vm.$set(permission, "activated", $$v)
                                        },
                                        expression: "permission.activated",
                                      },
                                    }),
                                    permission.subEntities
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "see-more-container",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleOpenAccordion(
                                                  permission.idEntity
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "see-more-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.renderSeeMoreText(
                                                      permission.subEntities
                                                        .panelIsOpened
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("span", {
                                              class: [
                                                _vm.renderSeeMoreIcon(
                                                  permission.subEntities
                                                    .panelIsOpened
                                                ),
                                                "see-more-icon",
                                              ],
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    key: _vm.componentKey,
                                    staticClass: "checkboxes-container",
                                  },
                                  _vm._l(
                                    permission.type,
                                    function (checkboxValue, type) {
                                      return _c("CheckboxComponent", {
                                        key: `${permission.label}-${type}`,
                                        staticClass: "checkbox-component",
                                        attrs: {
                                          id: `${permission.label}-${type}`,
                                          value: checkboxValue,
                                          disabled: _vm.checkIfDisableCheckbox(
                                            permission,
                                            type
                                          ),
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.checkboxesLogic(
                                              permission.idEntity,
                                              type,
                                              checkboxValue
                                            )
                                          },
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ]),
                            ]),
                            permission.subEntities
                              ? _c(
                                  "v-expansion-panel-content",
                                  [
                                    _c("LexonAutocompleteComponent", {
                                      attrs: {
                                        label:
                                          permission.subEntities
                                            .autocompleteLabel,
                                        propItems: permission.subEntities.items,
                                        multiple: "",
                                        chips: "",
                                        addNew: false,
                                        showSelectAll: true,
                                        value:
                                          permission.subEntities.selectedItems,
                                        itemName: "name",
                                        itemValue: "idEntity",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.selectAutocompleteItems(
                                            $event,
                                            permission.idEntity
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
            ]),
          ])
        : _c("SpinnerLayerComponent", { staticClass: "spinner-layer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }